let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b0HfI")).then(() => parcelRequire('6wrLV'));